import LoginTopBanner from "../../layout/AuthLayout/authTopbanner";
import { useTranslation } from "react-i18next";
import Success from "../../assests/new-images/success.png";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";


export default function SuccessLayout({ module ,title, message, routingURL}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.state) {
      navigate("/login");
    } 
  }, []);

  return (
    <>
      <div id="Auth" className="container-section">
      <LoginTopBanner module={module} title={title} />
        <div style={{ overflow: "hidden" }} className="mt-4">
          <div className="otp-auth-card overflow-auto text-center">
            <img className="mt-4 mb-3" src={Success} />
            <p>{location.state?.message}</p>
            <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                navigate(location.state?.routingURL);
              }}
              type="primary"
              className="login-button"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}
